import {
  LegacyDataTable,
  Panel,
  Tooltip,
} from "@validereinc/common-components";
import * as PropTypes from "prop-types";
import React from "react";
import { AutoSizer } from "react-virtualized";
import { sortByMultiplier, sortByProductType } from "../SourceTableHelper";
import useFilterInputs from "./InventorySourceTableFilter";

const InventorySourceTable = ({
  sourceKey,
  sources,
  showMultiplier,
  disabled,
  onSourceChecked,
  onEditClick,
}) => {
  const [filterRow, filterPillbox, filteredSourceList] =
    useFilterInputs(sources);

  const onSourceCheckboxClick = (checkedSource) => {
    onSourceChecked(checkedSource, sourceKey);
  };

  const nameRenderer = (rowData, columnKey) => {
    const name = rowData[columnKey];

    if (name) {
      return (
        <Tooltip content={name}>
          <div className="sourceTable__name">{name}</div>
        </Tooltip>
      );
    }

    return "-";
  };

  const multiplierRenderer = (rowData, columnKey) => {
    const multiplier = rowData[columnKey];

    if (multiplier || multiplier === 0) {
      return `${multiplier}x`;
    }

    return "-";
  };

  const multiplierFactor = () => {
    return showMultiplier
      ? [
          {
            label: "Multiplier Factor",
            key: "multiplier",
            width: 150,
            cellRenderer: multiplierRenderer,
            sort: sortByMultiplier,
          },
        ]
      : [];
  };

  const actionRenderer = (rowData) => {
    return (
      <a
        className="link"
        onClick={() => onEditClick(sourceKey, rowData)}
      >
        Edit
      </a>
    );
  };

  const actionColumn = () => {
    return onEditClick && !disabled
      ? [
          {
            label: "Actions",
            key: "actions",
            cellRenderer: actionRenderer,
            width: 75,
            disableSort: true,
          },
        ]
      : [];
  };

  const Headers = [
    {
      label: "Name",
      key: "name",
      width: 250,
      cellRenderer: nameRenderer,
      fixed: true,
    },
    {
      label: "Product Type",
      key: "product_type",
      width: 150,
      sort: sortByProductType,
    },
    {
      label: "Site",
      key: "site_name",
      width: 250,
    },
    ...multiplierFactor(),
    ...actionColumn(),
  ];

  return (
    <Panel>
      <div className="balanceSourceTable">
        <AutoSizer>
          {({ height, width }) => (
            <LegacyDataTable
              width={width}
              height={height}
              headers={Headers}
              list={filteredSourceList}
              filterKey="name"
              filterTitle="Name"
              defaultSortBy="name"
              defaultSortDirection="asc"
              onCheckboxClick={
                onSourceChecked && !disabled ? onSourceCheckboxClick : undefined
              }
              filterRow={filterRow}
              filterPillbox={filterPillbox}
            />
          )}
        </AutoSizer>
      </div>
    </Panel>
  );
};

InventorySourceTable.propTypes = {
  title: PropTypes.string,
  sourceKey: PropTypes.string,
  sources: PropTypes.array.isRequired,
  showMultiplier: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  openSourceSelectionModal: PropTypes.func,
  onEditClick: PropTypes.func,
  onSourceChecked: PropTypes.func,
};

export default InventorySourceTable;
